import {
  ListItem,
  ListItemIcon,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import CircleIcon from '@mui/icons-material/Circle';
import { OrganisationAccessConcentFieldsFragment } from '../../../../generated/core-api/graphql-react-query';
import StyledList from './styles';

interface LinksFormProps {
  organisation: OrganisationAccessConcentFieldsFragment;
}

export default function LinksForm(props: LinksFormProps) {
  const { i18n } = useTranslation();
  const {
    organisation,
  } = props;

  let links = [];
  if (i18n.language.includes('fr')) {
    links = organisation.additionalConsentUrlsFR;
  } else {
    links = organisation.additionalConsentUrlsEN;
  }

  return (
    <StyledList>
      {links?.map((link) => (
        <ListItem
          key={link.displayText}
          disableGutters
        >
          <ListItemIcon>
            <CircleIcon />
          </ListItemIcon>
          <Typography component="a" variant="body1" target="_blank" href={link.url}>{link.displayText}</Typography>
        </ListItem>
      ))}
    </StyledList>
  );
}
